export const appName = 'maps';
